module.exports = __webpack_public_path__ + "media/images/tmp/slide5-62b3cace22d30f905665e50979766a90.jpg";